"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CovidSelectors = require("pricing-pages-unified-ui/selectors/CovidSelectors");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _LocalStorageKeys = require("pricing-pages-unified-ui/constants/LocalStorageKeys");

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-column-gap: 20px;\n  align-items: center;\n  width: 100%;\n\n  &.public-banner {\n    max-width: 1200px;\n  }\n\n  @media (max-width: 767px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr auto;\n    grid-row-gap: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var localeToMarch2020LearnMoreUrl = {
  en: 'https://offers.hubspot.com/customer-changes-march-2020?source=pricing-page-banner',
  es: 'https://offers.hubspot.es/customer-changes-march-2020?source=pricing-page-banner',
  fr: 'https://offers.hubspot.fr/changements-apportes-mars-2020?source=pricing-page-banner',
  de: 'https://offers.hubspot.de/customer-changes-march-2020?source=pricing-page-banner',
  ja: 'https://offers.hubspot.jp/customer-changes-march-2020?source=pricing-page-banner',
  pt: 'https://br.hubspot.com/ofertas/customer-changes-march-2020?source=pricing-page-banner'
};

var CovidBannerGrid = _styledComponents.default.div.withConfig({
  displayName: "CovidRemoteSalesToolsBanner__CovidBannerGrid",
  componentId: "sc-1ew1n53-0"
})(_templateObject());

var CovidRemoteSalesToolsBanner = function CovidRemoteSalesToolsBanner(_ref) {
  var shouldShow = _ref.shouldShow,
      isInAppPage = _ref.isInAppPage;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      closeClicked = _useState2[0],
      setCloseClicked = _useState2[1];

  if (!shouldShow || closeClicked || localStorage.getItem(_LocalStorageKeys.COVID_REMOTE_SALES_TOOLS_CLOSED) === 'true') return null;

  var handleCloseClicked = function handleCloseClicked() {
    localStorage.setItem(_LocalStorageKeys.COVID_REMOTE_SALES_TOOLS_CLOSED, 'true');
    setCloseClicked(true);
  };

  return _react.default.createElement(_UIAlert.default, {
    type: "info",
    closeable: true,
    onClose: handleCloseClicked,
    className: isInAppPage ? '' : 'remote-alert-center'
  }, _react.default.createElement(CovidBannerGrid, {
    className: (0, _classNames.default)(!isInAppPage && 'public-banner')
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "covidSalesToolsBannerV2"
  }), _react.default.createElement(_UIButton.default, {
    size: "small",
    use: "tertiary",
    href: isInAppPage ? _urls.remoteSalesToolsUrl : (0, _urls.langToUrl)(localeToMarch2020LearnMoreUrl),
    external: !isInAppPage
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "learnMoreButtonCTA"
  }))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isInAppPage: (0, _ConfigSelectors.isAppAuthSelector)(state),
    shouldShow: (0, _CovidSelectors.shouldShowCovidRemoteSalesToolsPromo)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CovidRemoteSalesToolsBanner);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CovidRemoteSalesToolsBanner.js
// module id = 606
// module chunks = 5 6